import React from 'react';
import styled from 'styled-components';
import { Captions, ShortBody } from 'components/Typography';

export const Container = styled(({ isOpen, ...otherProps }) => (
  <div {...otherProps} />
))`
  background-color: #f2f2f2;
  padding: 12px 21px;
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
`;
export const StyledShortBody = styled(ShortBody)`
  &&& {
    margin-bottom: 4px;
  }
`;
export const StyledCaptions = styled(Captions)`
  &&& {
    margin-bottom: 0px;
  }
`;
export const StyledRedirection = styled.a`
  text-decoration: none;
`;
